module.exports = __webpack_public_path__ + "static/woman-lamp.664202ef.jpg";